export default __webpack_public_path__ + "static/media/icon_7.3da454b2.svg";